export default __webpack_public_path__ + "icon-cookie.png?6aa4e2eb3fdbc30ed94a1f718e21f22b";